import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-dialogo-decla-sugerida',
  templateUrl: './dialogo-decla-sugerida.component.html',
  styleUrls: ['./dialogo-decla-sugerida.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoDeclaSugeridaComponent implements OnInit {
  public annioGravable:String;
  constructor(
  		public dialogRef: MatDialogRef<DialogoDeclaSugeridaComponent>, 
      @Inject(MAT_DIALOG_DATA) private data: any
      ) { 
        this.annioGravable = this.data;
        
    	}

    ngOnInit() {
    }

    public onNoClick(): void {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/declaracion-sugerida/dialogo-decla-sugerida/dialogo-decla-sugerida.component.ts